module.exports = __webpack_public_path__ + "img/wupinqingjie_icon_zj.c14de817.png";